import { getState } from '@web/common/ExternalConfig/ExternalConfig'
import locale from '@web/common/locale'
import {
  ClubInApp,
  Question,
  translate,
  PointsInfo,
  AppsflyerSmartBanner,
  MobileAppWebBottomBar,
  MobileAppDesktopQrModal,
  CareServicesUrls,
  CareChatConfig,
  ExternalConfigSpecialCourse,
  ExternalConfigPersonalSelection,
  ExternalConfigSpecialPriceTrialServiceIds,
  ExternalConfigCategoryOverride
} from '@web/store/types/modules/assets'
import {
  CARE_CHAT_BUTTON_ID,
  CARE_CHAT_BUTTON_HASH,
  CARE_CHAT_GSO_BASE_URL,
  CARE_CHAT_ENABLED
} from '@web/common/config'
import getBaseUrl from '@web/common/getBaseUrl'
import {
  getSpecialHomeConst
} from '@web/consts/specialHome'

export const isOfflineEnable = (): boolean => Boolean(getState().data.isOfflineEnable)
export const isUserAnonAuthEnable = (): boolean => Boolean(getState().data.isUserAnonAuthEnable)
export const isRegistrationEnable = (): boolean => Boolean(getState().data.isRegistrationEnable)
// Поиск по курсам и материалам клуба (MOB-276). Без флага точки входа в
// шапках не показываем; сама страница /search при этом остаётся доступной.
export const isSearchEnable = (): boolean => Boolean(getState().data.isSearchEnable)

export const passHomeworkSupportCategoryId = (): number | undefined => getState().data.passHomeworkSupportCategoryId
export const renewCourseSupportCategoryId = (): number | undefined => getState().data.renewCourseSupportCategoryId
export const renewConsultationSupportCategoryId = (): number | undefined => getState().data.renewConsultationSupportCategoryId

export const welcomeMessages = (): translate[] => getState().data?.userInfoChat?.welcomeMessages || []
export const questions = (): Question[] => getState().data?.userInfoChat?.questions || []
export const goodbyeMessages = (): translate[] => getState().data?.userInfoChat?.goodbyeMessages || []

export const minSaveViewedMS = (): number | undefined => getState().data?.statistic?.MIN_SAVE_VIEWED_MS
export const minSaveViewedMSDayStatusFinished = (): number | undefined => getState().data?.statistic?.MIN_SAVE_VIEWED_MS_VIDEO_ENDED
export const timeoutSaveStatistic = (): number | undefined => getState().data?.statistic?.TIMEOUT_SAVE_STATISTIC
export const messageDelay = (): number => getState().data?.messageDelay || 15
export const isDemoAccessible = (): boolean => Boolean(getState().data.isDemoAccessible)
export const isVideoConsultationSupport = (): boolean => Boolean(getState().data.isVideoConsultationSupport)
export const isBannerEnable = (): boolean => Boolean(getState().data.isBannerEnable)
export const saleEmail = (): string => getState().data.saleEmail || 'sale@anyclass.com'
export const isAppStoreSupport = (): boolean => Boolean(getState().data.isAppStoreSupport)
export const daysShowWarning = (): number => getState().data.daysShowWarning || 0
export const isChatSupport = (): boolean => Boolean(getState().data.isChatSupport)
export const socialAuth = (): { android: string[]; ios: string[] } => getState().data.socialAuth
export const daysNoticeRenew = (): number => getState().data.daysShowWarning || 3
export const instructionUrl = (): string => getState().data.instructionUrl?.[locale.get()] || ''
export const guidelineUrl = (): string => getState().data.guidelineUrl?.[locale.get()] || ''
export const communityUrlFrontend = (): string => getState().data.communityUrlFrontend || ''
export const communityUrlApi = (): string => {
  const url = getState().data.communityUrlApi || ''
  return url ? new URL(getBaseUrl(url), window.location.toString()).toString() : ''
}
export const clubRecommendedLandingUrls = (): Record<string, string> => getState().data.clubRecommendedLandingUrls || {}
export const clubInApp = (): ClubInApp => getState().data.clubInApp || {}
export const pointsInfo = (): PointsInfo => getState().data.pointsInfo || {
  countPointsToDebit: 200,
  links: {},
  faq: []
}
export const cookiePolicyLink = (): string => getState().data.cookiePolicyLink || ''
export const appsflyerSmartBanner = (): AppsflyerSmartBanner => getState().data.appsflyerSmartBanner || {}
export const mobileAppWebBottomBar = (): MobileAppWebBottomBar => getState().data.mobileAppWebBottomBar || { visible: false }
export const mobileAppDesktopQrModal = (): MobileAppDesktopQrModal => getState().data.mobileAppDesktopQrModal || { visible: false }
export const careServicesUrls = (): CareServicesUrls => getState().data.careServicesUrls || { telegram: '', whatsapp: '', max: '' }

const careChatConfig = (): CareChatConfig => getState().data.careChat || {}
export const careChatEnabled = (): boolean => {
  const fromState = careChatConfig().enabled
  if (typeof fromState === 'boolean') return fromState
  return CARE_CHAT_ENABLED
}
export const careChatButtonId = (): string => careChatConfig().crmButtonId || CARE_CHAT_BUTTON_ID
export const careChatButtonHash = (): string => careChatConfig().crmButtonHash || CARE_CHAT_BUTTON_HASH
export const careChatGsoBaseUrl = (): string => careChatConfig().gsoBaseUrl || CARE_CHAT_GSO_BASE_URL
export const careChatLeadFieldId = (): number | null => careChatConfig().crmLeadFieldId ?? null
export const superSubscriptionsIds = (): number[] => getState().data?.superSubscriptionsIds || []

export const lkSegmentIds = (): number[] => getState().data.segments?.lkSegmentIds || getState().data.lkSegmentIds || []
export const newOfferModalSegment = (): number => getState().data.segments?.newOfferModal || getState().data.newOfferModalSegment || 0
export const superSubscriptionSegment = (): number => getState().data.segments?.superSubscription || 0
export const coursesWithSelfieSegment = (): number => getState().data.segments?.coursesWithSelfie || 0
export const ffNmsSegment = (): number => getState().data.segments?.ffNms || 0
export const specialProjectId = (): 'any' | 'take' => getState().data.projectId as 'any' | 'take'
export const specialPriceTrial = (): string => getState().data.specialPriceTrial || getSpecialHomeConst(specialProjectId()).defaultSpecialPriceTrial
export const specialPriceTrialServiceIds = (): ExternalConfigSpecialPriceTrialServiceIds => getState().data.specialPriceTrialServiceIds || {}
export const specialRecommendedCourseIds = (): number[] => getState().data.newHome?.courseIds?.recommended || []
export const specialNewCourseIds = (): number[] => getState().data.newHome?.courseIds?.new || []
export const specialTopSaleCourseIds = (): number[] => getState().data.newHome?.courseIds?.topSale || []
export const specialCourseMap = (): Record<number, ExternalConfigSpecialCourse> => getState().data.newHome?.specialCourseId || getSpecialHomeConst(specialProjectId()).defaultSpecialCourseId
export const specialCourseIdsInSubscription = (): Record<number, number> => getState().data.newHome?.specialCourseIdsInSubscription || getSpecialHomeConst(specialProjectId()).defaultSpecialCourseIdsInSubscription
export const specialPaywallServiceId = (): number => getState().data.newHome?.paywallServiceId || getSpecialHomeConst(specialProjectId()).defaultPaywallServiceId
export const specialQuizLink = (): string => getState().data.newHome?.specialQuizLink || getSpecialHomeConst(specialProjectId()).defaultLinkQuiz
export const coursesForShowModalNewOffer = (): number[] => getState().data.newHome?.coursesForShowModalNewOffer || getSpecialHomeConst(specialProjectId()).coursesForShowModalNewOffer
export const coursesForHideModalNewOffer = (): number[] => getState().data.newHome?.coursesForHideModalNewOffer || getSpecialHomeConst(specialProjectId()).coursesForHideModalNewOffer
export const specialPersonalSelection = (): ExternalConfigPersonalSelection | undefined => getState().data.newHome?.personalSelection
export const specialRecommendationTagId = (): number | undefined => getState().data.newHome?.recommendationTagId
export const specialCategoryOverrides = (): ExternalConfigCategoryOverride[] => getState().data.newHome?.categoryOverrides || []
